// views/Map/composables/usePositions.js
// Fonctions utilitaires liées aux positions géographiques

/**
 * Normalise un tableau de positions (balises, pings, etc.)
 * - Force latitude/longitude en Number
 * - Supprime les points invalides
 * - Conserve les autres champs intacts
 */
export function normalizePositions(arr) {
    if (!Array.isArray(arr)) return [];
    return arr
        .map(p => ({
            ...p,
            latitude: Number(p.latitude ?? p.lat),
            longitude: Number(p.longitude ?? p.lng),
        }))
        .filter(p => Number.isFinite(p.latitude) && Number.isFinite(p.longitude));
}
